import { SchemaScript } from "@tokenterminal/core/ui/seo/SchemaScript"
import { SITE_URL } from "@tokenterminal/core/ui/seo/SiteSchemas"

export interface Breadcrumb {
  name: string
  /** Site path, e.g. "/resources" */
  path: string
}

/** BreadcrumbList JSON-LD, from the top level down to the current page. */
export const BreadcrumbSchema = ({ items }: { items: Breadcrumb[] }) => (
  <SchemaScript
    id="breadcrumbs"
    schema={{
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map(({ name, path }, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name,
        item: `${SITE_URL}${path}`,
      })),
    }}
  />
)
